import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import EditDialog from "../../../../Components/Common/EditDialog";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { useUser } from "../../../../context/AuthContext";
// import formatTitleWithOptional from "../../OptionalFeild";

function Add({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    importer: data?.importer || "",
    typeOfRenewableEnergy: data?.typeOfRenewableEnergy || "",
    energyExported: data?.energyExported === 0 ? 0 : data?.energyExported || "",
    emissionFactor: data?.emissionFactor === 0 ? 0 : data?.emissionFactor || "",
    remarks: data?.remarks || "",
    documents: data?.documents || [],
    editRemarkReason: data?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  // const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  // const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year

  useEffect(() => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  }, [data, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log(name, value);

    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    if (
      name.startsWith("calorificValue.") ||
      name.startsWith("quantityConsumed.")
    ) {
      const [field, key] = name.split(".");
      console.log(field, key);

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else {
      console.log("firstname", name, value);
      if (name === "equipmentType")
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          industrialEquipment: "",
          typeOfEntry: "",
        }));
      else setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    // setSelectedMonth(data?.monthYear?.month || "");
    // setSelectedYear(data?.monthYear?.year || "");
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    setUploadedFiles(data?.documents || []); // Reset uploaded files
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData2[key] === formData[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const validateForm = () => {
    const newErrors = {};
    console.log(formData);

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      if (input.fieldName === "documents") return;

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
      // consumptionPeriod:{month:selectedMonth,year:selectedYear}
    };
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }

    let method = id ? put : post;
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;

    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData(initialState);
        setUploadedFiles([]);
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Month of energy export"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }

    if (el.options || el.type === "select") {
      console.log("firsturl", el.url, formData, el.fieldName);

      return (
        <SelectField
          // title={el.title}
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={
            el?.fieldName === "industrialEquipment"
              ? `${el?.url}&equipmentId=${formData?.equipmentType}`
              : el.url
          }
          field={el.field}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          // title={el.title}
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          // title={el.title}
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }

    return (
      <InputField
        // title={el.title}
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={formData[el.fieldName] === 0 ? 0 : formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""} // Pass error prop
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.5rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title}` : `Add ${title}`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  console.log("inside", data, formData);
  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default Add;
